<template>
    <div class="chlorid-ionen">
        <p>
            Zugabe von Silbernitrat ergibt weißen Niederschlag durch unlösliches
            Silberchlorid
            <br />
            Ag<sup>+</sup> + Cl<sup>-</sup> → AgCl
            <br />
            Ag<sup>+</sup> aus AgNO<sub>3</sub>
        </p>
    </div>
</template>

<script>
export default {
    name: 'chlorid-ionen',
};
</script>
